export default __webpack_public_path__ + "static/media/gallery-3.58f650dd.jpg";